export const adminMobileNavbarData = [
  {
    "name": "Home",
    "route": "/admin",
    "icon": "home"
  },
  {
    "name": "Employees",
    "route": "/admin/employees",
    "icon": "users"
  },
  {
    "name": "Stores",
    "route": "/admin/stores",
    "icon": "store"
  },
  {
    "name": "More",
    "route": "/admin/more",
    "icon": "more"
  }
]

export const morePageData = [
  {
    "name": "My Subscription",
    "route": "/subscription",
    "icon": "subscription",
  },
  {
    "name": "Settings",
    "route": "/settings",
    "icon": "settings",
  },
]

export const adminSidebarData = [
  {
    "name": "Home",
    "route": "/admin",
    "icon": "home"
  },
  {
    "name": "Employees",
    "route": "/admin/employees",
    "icon": "users"
  },
  {
    "name": "Stores",
    "route": "/admin/stores",
    "icon": "store"
  },
  {
    "name": "My Subscription",
    "route": "/subscription",
    "icon": "subscription"
  },
  {
    "name": "Settings",
    "route": "/settings",
    "icon": "settings"
  },
]

export const cashierSidebarData = [
  {
    "name": "Home",
    "route": "/cashier",
    "icon": "home"
  },
  {
    "name": "Items",
    "route": "/cashier/items",
    "icon": "items"
  },
  {
    "name": "Customers",
    "route": "/cashier/customers",
    "icon": "customers"
  },
  {
    "name": "My Subscription",
    "route": "/subscription",
    "icon": "subscription"
  },
  {
    "name": "Settings",
    "route": "/settings",
    "icon": "settings"
  },
]

export const cashierMobileNavbarData = [
  {
    "name": "Home",
    "route": "/cashier",
    "icon": "home"
  },
  {
    "name": "Items",
    "route": "/cashier/items",
    "icon": "items"
  },
  {
    "name": "Customers",
    "route": "/cashier/customers",
    "icon": "customers"
  },
  {
    "name": "More",
    "route": "/cashier/more",
    "icon": "more"
  },
]

export const managerSidebarData = [
  {
    "name": "Home",
    "route": "/manager",
    "icon": "home"
  },
  {
    "name": "Employees",
    "route": "/manager/employees",
    "icon": "users"
  },
  {
    "name": "Items",
    "route": "/manager/items",
    "icon": "items"
  },
  {
    "name": "My Subscription",
    "route": "/subscription",
    "icon": "subscription"
  },
  {
    "name": "Settings",
    "route": "/settings",
    "icon": "settings"
  },
]

export const managerMobileNavbarData = [
  {
    "name": "Home",
    "route": "/manager",
    "icon": "home"
  },
  {
    "name": "Employees",
    "route": "/manager/employees",
    "icon": "users"
  },
  {
    "name": "Items",
    "route": "/manager/items",
    "icon": "items"
  },
  {
    "name": "More",
    "route": "/manager/more",
    "icon": "more"
  },
]
